import styled from 'styled-components';

export const LabelCardQuestion = styled.p`
    font-family: 'Roboto';
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 5px;
`;

export const DescriptionCardQuestion = styled.p`
    font-family: 'Roboto';
    font-size: 12px;
    font-weight: 300;
    margin-top: 0;
`;
